module.exports = __webpack_public_path__ + "img/0960036b-f6e0-4209-a78d-e9d6e2708712_base_resized.227b68ee.jpg";